(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["group"] && !Shopify.designMode) return;
  try {
    /*
   * Mobile carousel interactions
   *
   * 1. Mouse-drag support — lets the carousel scroll via click-and-drag in desktop
   *    browsers and the Shopify theme-editor preview, matching native touch behaviour.
   *
   * 2. Tap-to-navigate — when a .group-block__link sibling is present, a short tap
   *    (no significant movement) navigates to its href. On real mobile the browser
   *    never fires a click after a real swipe (movement > ~10 px), so the two gestures
   *    are naturally distinguished without any extra threshold logic.
   *
   * The handlers are registered once on document (guarded by _mbCarousel) so multiple
   * carousel blocks on the same page share a single listener pair.
   */
  (function () {
    if (window._mbCarousel) return;
    window._mbCarousel = true;

    var drag = { el: null, startX: 0, startScroll: 0, moved: false };

    document.addEventListener('mousedown', function (e) {
      var carousel = e.target.closest && e.target.closest('.mobile-carousel');
      if (!carousel || e.button !== 0) return;
      drag.el = carousel;
      drag.startX = e.clientX;
      drag.startScroll = carousel.scrollLeft;
      drag.moved = false;
      e.preventDefault(); // prevent text selection during drag
    });

    document.addEventListener('mousemove', function (e) {
      if (!drag.el) return;
      var delta = drag.startX - e.clientX;
      if (Math.abs(delta) > 5) drag.moved = true;
      drag.el.scrollLeft = drag.startScroll + delta;
    });

    document.addEventListener('mouseup', function () {
      drag.el = null;
    });

    /*
     * Click handler (capture phase so we can cancel it before other listeners).
     * - After a mouse-drag: swallow the synthetic click so it doesn't navigate.
     * - After a short tap/click on a carousel with a block link: navigate to the
     *   link's href.  We skip the navigation if the actual target is already an
     *   interactive element (a, button) so those keep their own click behaviour.
     */
    document.addEventListener('click', function (e) {
      var carousel = e.target.closest && e.target.closest('.mobile-carousel');
      if (!carousel) return;

      if (drag.moved) {
        drag.moved = false;
        e.preventDefault();
        return;
      }

      var link = carousel.previousElementSibling;
      if (!link || !link.classList.contains('group-block__link') || !link.href) return;
      if (e.target.closest('a, button')) return;

      if (link.target === '_blank') {
        window.open(link.href, '_blank', 'noopener');
      } else {
        window.location.href = link.href;
      }
    }, true);
  })();

  /*
   * Reversed carousel — visual reorder via CSS `order`.
   *
   * Sets flex `order` on each child to flip their visual position without
   * touching the DOM or scroll position. scrollLeft stays 0 so the carousel
   * always opens at the first reversed item and the user swipes left normally.
   * Cleared above 1079px so desktop layout is unaffected.
   */
  (function () {
    var mq = window.matchMedia('(max-width: 1079px)');

    function applyAll() {
      var isMobile = mq.matches;
      document.querySelectorAll('.mobile-carousel.reverse-mobile').forEach(function (carousel) {
        var children = Array.from(carousel.children);
        var n = children.length;
        children.forEach(function (child, i) {
          child.style.order = isMobile ? String(n - 1 - i) : '';
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyAll);
    } else {
      applyAll();
    }

    mq.addEventListener('change', applyAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-grouping"] && !Shopify.designMode) return;
  try {
    (function () {
    function initializeProductGroupingHover() {
      const productGrouping = document.querySelector('.product-grouping');
      if (!productGrouping) return;
      const swatchContainers = productGrouping.querySelectorAll('.product-grouping__swatches');

      swatchContainers.forEach((swatchContainer) => {
        const legend = swatchContainer.previousElementSibling;
        if (!legend) return;

        const colorSpan = legend.querySelector('.product-grouping__color');
        if (!colorSpan) return;

        let defaultColor = colorSpan.dataset.defaultColor || colorSpan.textContent.trim();
        if (colorSpan.dataset.defaultColor) {
          colorSpan.textContent = colorSpan.dataset.defaultColor;
        }
        const swatchLabels = swatchContainer.querySelectorAll('label[data-color-name]');

        swatchLabels.forEach((label) => {
          const colorName = label.dataset.colorName;
          if (!colorName) return;

          const newLabel = label.cloneNode(true);
          label.parentNode?.replaceChild(newLabel, label);

          newLabel.addEventListener('mouseenter', () => {
            colorSpan.textContent = colorName;
          });

          newLabel.addEventListener('mouseleave', () => {
            if (defaultColor) {
              colorSpan.textContent = defaultColor;
            }
          });

          const input = newLabel.querySelector('input');
          if (input) {
            input.addEventListener('change', () => {
              defaultColor = colorName;
              colorSpan.dataset.defaultColor = colorName;
              colorSpan.textContent = colorName;
            });
          }
        });
      });
    }

    initializeProductGroupingHover();
    const observer = new MutationObserver((mutations) => {
      let shouldReinit = false;
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            if (node.classList?.contains('product-grouping') || node.querySelector?.('.product-grouping')) {
              shouldReinit = true;
            }
          }
        });
        if (mutation.type === 'attributes' && mutation.target.classList?.contains('product-grouping')) {
          shouldReinit = true;
        }
      });
      if (shouldReinit) {
        requestAnimationFrame(() => {
          initializeProductGroupingHover();
        });
      }
    });

    const main = document.querySelector('main');
    if (main) {
      observer.observe(main, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'data-product-id', 'data-product-url'],
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
